import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { ChanelConfig } from '../../../../../configs/GlobalConfig';
import MessageHub from '../../../../../core/signalr/SignalrMessageHub';
import TabFilter from '../../../../common/tab-filter';
import { getDefaultIfEmpty } from '../../../../helpers/Common';
import {
  cancelfetchDataCancelled,
  fetchDataCancelled,
  subscribeRealtimeTickCancelled,
  changeFilterLineOne,
  REDUCER_NAME,
  loadMoreCancelled,
} from '../reducer';
import { SimpleTooltip } from '../../../../common/tooltip';
import Const from './Const';
import Table from './Table';
import { formatTextFloat } from '../../../../helpers/Text';

const defaultSortState = { totalMatchedVolume: 'desc' };

class Cancelled extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      sortState: defaultSortState,
    };
    this.tableRef = React.createRef();
  }

  componentDidMount() {
    this.fetchData();
    MessageHub.subscribe(ChanelConfig.TickChanel, this.dispatchDataRealtime);
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const { currentSearch, watchListId } = this.props;
    if (
      currentSearch !== nextProps.currentSearch ||
      watchListId !== nextProps.watchListId
    ) {
      this.setState({ page: 1 });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { sortState } = this.state;
    const { currentSearch, watchListId, filter } = this.props;
    if (
      currentSearch !== prevProps.currentSearch ||
      watchListId !== prevProps.watchListId ||
      sortState !== prevState.sortState ||
      filter !== prevProps.filter
    ) {
      this.fetchData();
      if (this.tableRef.current) {
        this.tableRef.current.scrollToTop();
      }
    }
  }

  componentWillUnmount() {
    const { cancelfetchDataCancelled } = this.props;
    cancelfetchDataCancelled();
    MessageHub.unsubscribe(ChanelConfig.TickChanel, this.dispatchDataRealtime);
  }

  fetchData = () => {
    const { sortState } = this.state;
    const { fetchDataCancelled, filter } = this.props;
    fetchDataCancelled(Const.filterAvgVolume[filter.filterLineOne], sortState);
  };

  onLoadMore = page => {
    const { sortState } = this.state;
    const { loadMoreCancelled, filter } = this.props;
    loadMoreCancelled({
      page,
      sortState,
      currentAvgVolume: Const.filterAvgVolume[filter.filterLineOne],
    });
    this.setState({
      page,
    });
  };

  dispatchDataRealtime = data => {
    const { subscribeRealtimeTickCancelled } = this.props;
    subscribeRealtimeTickCancelled(data);
  };

  changeAvgVolume = currentAvgVolume => {
    const { changeFilterLineOne, filter } = this.props;
    if (filter.filterLineOne !== currentAvgVolume) {
      changeFilterLineOne(currentAvgVolume);
    }
  };

  onSort = sortState => {
    this.setState({
      sortState: getDefaultIfEmpty(sortState, defaultSortState),
    });
  };

  render() {
    const { page } = this.state;
    const { filter } = this.props;
    return (
      <div className="d-flex flex-column flex-fill">
        <div>
          <div className="list-filter top-nav">
            <span className="mr-10 left-label">
              {I18n.t('tasignals.cancelledContent.line_2')}{' '}
            </span>
            <TabFilter
              currentTab={filter.filterLineOne}
              listTab="tasignals.filterAvgVolume"
              changeTab={this.changeAvgVolume}
            />
          </div>
          <div className="list-text-display">
            <span className="light-text">
              {I18n.t('tasignals.cancelledContent.line_3.part_1')}
            </span>
            <span className="bold-text">
              {I18n.t('tasignals.cancelledContent.line_3.part_2')}
              {formatTextFloat(
                Number(Const.filterAvgVolume[filter.filterLineOne]),
                0,
              )}
            </span>
            <span className="light-text">
              {I18n.t('tasignals.cancelledContent.line_3.part_3')}
            </span>
            <span className="bold-text">
              {I18n.t('tasignals.cancelledContent.line_3.part_4')}
            </span>
          </div>
        </div>
        <div className="mt-10 d-flex flex-fill">
          <Table
            page={page}
            scrollRef={this.tableRef}
            onLoadMore={this.onLoadMore}
            onSort={this.onSort}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    currentSearch: state[REDUCER_NAME].currentSearch,
    watchListId: state[REDUCER_NAME].watchListId,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchDataCancelled: (currentAvgVolume, sortState) =>
      dispatch(fetchDataCancelled(currentAvgVolume, sortState)),
    cancelfetchDataCancelled: () => dispatch(cancelfetchDataCancelled()),
    subscribeRealtimeTickCancelled: data =>
      dispatch(subscribeRealtimeTickCancelled(data)),
    changeFilterLineOne: value => dispatch(changeFilterLineOne(value)),
    loadMoreCancelled: value => dispatch(loadMoreCancelled(value)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Cancelled);
